import React from 'react';
interface PageHeroBannerProps {
  eyebrow: string;
  headline: string;
  subheadline: string;
  ctaPrimary?: {
    label: string;
    href: string;
  };
  ctaSecondary?: {
    label: string;
    href: string;
  };
}
export function PageHeroBanner({
  eyebrow,
  headline,
  subheadline,
  ctaPrimary,
  ctaSecondary
}: PageHeroBannerProps) {
  return <section className="w-full relative overflow-hidden" style={{
    backgroundColor: '#0283C7',
    paddingTop: '80px'
  }} data-id="element-562">
      {/* Subtle pattern */}
      <div className="absolute inset-0 pointer-events-none" style={{
      opacity: 0.06
    }} data-id="element-563">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-564">
          <defs data-id="element-565">
            <pattern id="hero-dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-566">
              <circle cx="20" cy="20" r="2" fill="white" data-id="element-567" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hero-dots)" data-id="element-568" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center" data-id="element-569">
        <p className="uppercase font-semibold mb-5 tracking-widest text-white" style={{
        fontSize: '13px',
        letterSpacing: '0.18em',
        fontFamily: 'Inter, sans-serif',
        opacity: 0.85
      }} data-id="element-570">
          {eyebrow}
        </p>
        <h1 className="font-bold text-white mb-6" style={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: 'clamp(28px, 5vw, 48px)',
        fontWeight: 900,
        lineHeight: 1.1
      }} data-id="element-571">
          {headline}
        </h1>
        <p className="max-w-2xl mx-auto mb-10" style={{
        color: 'rgba(255,255,255,0.85)',
        fontFamily: 'Inter, sans-serif',
        fontSize: 'clamp(15px, 1.8vw, 18px)',
        lineHeight: 1.7
      }} data-id="element-572">
          {subheadline}
        </p>

        {(ctaPrimary || ctaSecondary) && <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-573">
            {ctaPrimary && <a href={ctaPrimary.href} className="font-bold text-center py-4 px-10 rounded-lg transition-all hover:scale-[1.03] min-h-[52px] flex items-center justify-center" style={{
          backgroundColor: '#ffffff',
          color: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
        }} data-id="element-574">
                {ctaPrimary.label}
              </a>}
            {ctaSecondary && <a href={ctaSecondary.href} className="font-bold text-white text-center py-4 px-10 rounded-lg border-2 transition-all hover:bg-white hover:text-blue-600 min-h-[52px] flex items-center justify-center" style={{
          borderColor: '#ffffff',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          borderRadius: '8px'
        }} data-id="element-575">
                {ctaSecondary.label}
              </a>}
          </div>}
      </div>
    </section>;
}